import { useDispatch } from "react-redux";
import { useState } from "react";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import {useLazyGetCreditHistoriesQuery} from "../../../Store/Builder/techsbook.api";

const useCredits = (page, perPage) => {
    const dispatch = useDispatch();
    const [getCreditHistories] = useLazyGetCreditHistoriesQuery();

    const [credits, setCredits] = useState([]);

    const formatParams = () => {
        const pageParam = `${page ? '&' : ''}page=${page}${perPage && `&perPage=${perPage}`}`;
        return `${pageParam ? pageParam : ''}`;
    }

    const get = () => {
        dispatch(setLoader(true));
        const formattedParams = formatParams();
        getCreditHistories(formattedParams)
            .unwrap()
            .then((res) => {
                dispatch(setLoader(false));
                setCredits(res);
            })
            .catch((err) => {
                dispatch(setLoader(false));
                showToast(err?.data?.message ?? "Error", "error");
            });
    };

    return {
        get,
        credits,
    };
};

export default useCredits;
